<template>
<div class="map-route"
     :class="{ 'in-transition': inTransition }"
     :style="{ transform: `translateY(${translateY}px)`, top: `${topStr}` }"
     @touchstart="handleTouchStart"
     @touchmove="handleTouchMove"
     @touchend="handleTouchEnd"
     @touchcancel="handleTouchEnd"
     @transitionend="handleTransitionEnd"
     @transitioncancel="handleTransitionEnd">
  <div class="arrow-down" v-if="expand">
    <img src="../assets/slide-down.svg" />
  </div>
  <div class="line" v-else></div>
  <div class="route">
    <div class="route-brief" ref="brief">
      <cube-slide ref="slide"
                  class="route-slide"
                  :loop="false"
                  :autoPlay="false"
                  :data="routes"
                  :initialIndex="routeIndex"
                  @change="handleChangeSlide">
        <cube-slide-item v-for="(route, index) in routes"
                         :key="route.id + index">
          <div :class="routes.length===1?'cityWalk':'brief-wrapper'">
            <div class="route-name">{{ route.name }}</div>
            <div class="route-time" v-if="route.points">{{ $t('home.routeInfo', { amount: route.points.length, time: route.time || route.play_time}) }}</div>
          </div>
        </cube-slide-item>
      </cube-slide>
      <!-- <div class="route-mask" v-if="!expand"></div> -->
    </div>
    <div class="route-detail" ref="list" v-if="routes[routeIndex].points">
      <div class="detail-wrapper"
           @touchstart="handleStopTouch"
           @touchmove="handleStopTouchMove">
        <div class="subsite"
             v-for="(item, index) in routes[routeIndex].points"
             :key="item.id"
             @click="handleClickSite(index)">
          <div class="left">
            <div class="order">{{ index + 1 }}</div>
            <div class="name">{{ item.name }}</div>
          </div>
          <Score v-if="item.rating && $route.query.from !== 'CityWalk'" :rating="item.rating" />
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { clamp as _clamp } from 'lodash'
import Score from '@/components/Score'

export default {
  data () {
    return {
      hold: false,
      startY: 0,
      lastTouch: {
        y: 0,
        t: 0
      },
      speed: 0,
      translateY: 0,
      inTransition: false,
      expand: false,
      topStr: '100vh',
      scrollTop: 0
    }
  },
  props: {
    routes: {
      type: Array,
      default: () => {
        return [{ points: [] }]
      }
    },
    routeIndex: {
      type: Number,
      default: 0
    }
  },
  components: {
    Score
  },
  created() {
  	if (this.$store.state.isSentaosaWeb) {
  		this.topStr = '100%'
  	}
  },
  methods: {
    handleScroll (e) {
      this.scrollTop = e.y
    },
    handleStopTouch (e) {
      if (this.$refs.list.scrollTop > 0) {
        e.stopPropagation()
      }
    },
    handleStopTouchMove (e) {
      if (!this.expand) {
        e.preventDefault()
      }
      if (this.$refs.list.scrollTop > 0) {
        e.stopPropagation()
      }
    },
    // 开始滑动
    handleTouchStart (e) {
      if (this.inTransition) { return }

      this.hold = true
      this.startY = e.touches[0].clientY
      this.lastTouch = {
        y: e.touches[0].clientY,
        t: Date.now()
      }
    },
    // 滑动中
    handleTouchMove (e) {
      if (this.inTransition) { return }
      if (!this.hold) { return }

      const offsetY = e.touches[0].clientY - this.lastTouch.y
      const now = Date.now()
      const speed = offsetY / (now - this.lastTouch.t) * 1000
      let slideHeight = this.$refs.brief.clientHeight + 130
      const query = this.$route.query
      if (query.from === 'CityWalk') slideHeight += 50
      const windowHeight = window.innerHeight - 97

      this.translateY = _clamp(this.translateY + offsetY, slideHeight - windowHeight, 0)
      this.speed = speed
      this.lastTouch = {
        y: e.touches[0].clientY,
        t: now
      }
    },
    // 滑动结束
    handleTouchEnd () {
      if (this.inTransition) { return }
      if (!this.hold) { return }
      // const slideHeight = this.$refs.brief.clientHeight + 130
      const windowHeight = window.innerHeight - 97

      this.hold = false
      console.log('translateY', this.translateY)
      this.inTransition = true

      this.$nextTick(() => {
        setTimeout(() => {
          this.inTransition = false
        }, 300)
        const query = this.$route.query
        console.log('----query---', query)
        const heigth = 180
        const currentHeight = this.$refs.brief.clientHeight+heigth // 样式有变，重新计算高度
        console.log('speed', this.speed)
        if (this.speed > 0) { // 下滑
          if (this.translateY > -180) {
            this.translateY = 0
            this.expand = false
            this.$emit('mask', false)
          } else {
            this.translateY = currentHeight - windowHeight
            this.expand = true
            this.$emit('mask', true)
          }
        } else {
          if (this.translateY < -100) {
            this.translateY = currentHeight - windowHeight
            this.expand = true
            this.$emit('mask', true)
          } else {
            this.translateY = 0
            this.expand = false
            this.$emit('mask', false)
          }
        }
      })
    },
    // 展开详情
    handleExpand () {
      this.expand = true
      this.inTransition = true
      this.$emit('mask', true)
      this.$nextTick(() => {
        const currentHeight = this.$refs.brief.clientHeight + 130 // 样式有变，重新计算高度
        const windowHeight = window.innerHeight
        this.translateY = currentHeight - windowHeight
      })
    },
    // 关闭详情
    handleClose () {
      this.expand = false
      this.inTransition = true
      this.$emit('mask', false)
      this.$nextTick(() => {
        this.translateY = 0
		if (this.$store.state.isSentaosaWeb) {
			this.topStr = '100%'
		} else {
			this.topStr = '100vh'
		}
      })
    },
    handleTransitionEnd () {
      this.inTransition = false
    },
    handleStop () {},
    handleShow () {
      this.inTransition = true
      this.$nextTick(() => {
        this.topStr = `calc(${this.topStr} - 184px)`
        setTimeout(() => {
          this.inTransition = false
        }, 300)
      })
    },
    // 点击路线中的导览点
    handleClickSite (index) {
      console.log(index)
      this.$emit('select', this.routes[this.routeIndex].points[index])
    },
    handleChangeSlide (index) {
      this.$emit('changeIndex', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.map-route {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 12;
  background-color: #ffffff;
  border-radius: 8px 8px 0 0;
  padding-top: 13px;

  .line {
    width: 24px;
    height: 2px;
    background-color: #dddddd;
    margin: 0 auto ;
  }
  &.in-transition {
    transition: all .3s ease;
  }

  .arrow-down img {
    width: 29px;
    height: 8px;
    margin: 0 auto;
    display: block;
  }

  .route {
    .cityWalk{
      display: flex;
      align-self: center;
      justify-content: space-between;
      padding: 10px 12px;
    }
    .brief-wrapper {
      display: flex;
      align-self: center;
      justify-content: space-between;
      padding: 10px 12px 21px;
    }
    &-brief {
      border-bottom: 1px solid #f1f1f1;
      margin-bottom: 15px;
      position: relative;
      /*padding-bottom: 10px;*/

      .route-mask {
        position: absolute;
        left: 0;
        top: 100%;
        width: 100%;
        height: 100px;
        z-index: 1;
        margin-top: 15px;
      }
    }

    &-detail {
      padding: 0 12px 30px;
      height: calc(100vh - 189px);
      overflow: auto;
      margin-bottom: env(safe-area-inset-bottom);
    }

    .detail-wrapper {
      position: relative;
      &:after {
        content: '';
        height: calc(100% - 16px);
        position: absolute;
        left: 12px;
        top: 8px;
        width: 1px;
        background-color: rgba(255, 164, 0, 0.3);
      }
    }

    &-name {
      font-size: 15px;
      font-weight: bold;
      font-family: "Montserrat";
    }

    &-time {
      font-size: 12px;
      color: #888888;
    }

    .subsite {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 2px 8px 0;

      &:not(:first-child) {
        margin-top: 4px;
      }

      .left {
        display: flex;
        align-items: center;
      }

      .right {
        flex-shrink: 0;
      }

      .name {
        font-size: 14px;
        line-height: 20px;
        margin-left: 12px;
      }

      .order {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        border: 1px solid #ffa400;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: bold;
        font-family: "Montserrat";
        background-color: #ffffff;
        position: relative;
        z-index: 1;
      }
    }
  }
}
</style>
